export const environment = {
  production: true,
  apiUrl: 'https://api.uorder.io/',
  googleMapsApiKey: 'AIzaSyAeSK-s1BHd8JnKFOMgz70lCjkag6yKKNw',
  firebase: {
    apiKey: "AIzaSyAmtc855cBTKGeGHxbK6DfD1NU9PYvp6TM",
    authDomain: "uorder-d7e2f.firebaseapp.com",
    projectId: "uorder-d7e2f",
    storageBucket: "uorder-d7e2f.firebasestorage.app",
    messagingSenderId: "819148290964",
    appId: "1:819148290964:web:a4c6fc3604705c3f196d81",
    measurementId: "G-NTEFD997RC"
  }
};
